import { Addon } from '@domain/addon';

export const calculateAddonPrice = ({ addons, quantity }: { addons: Addon[]; quantity: number }) => {
  let number = 0;
  number += addons.reduce((sum: number, addon: Addon) => sum + addon.fixedPrice.amount * quantity, 0);
  return number;
};
